import { KeyboardEvent, TextareaHTMLAttributes } from 'react'
import cx from 'classnames'

export const allowTabCharacter = (e: KeyboardEvent<HTMLTextAreaElement>) => {
  if (e.key === 'Tab') {
    e.preventDefault()
    const start = e.currentTarget.selectionStart
    const end = e.currentTarget.selectionEnd
    e.currentTarget.value = `${e.currentTarget.value.substring(
      0,
      start
    )}\t${e.currentTarget.value.substring(end)}`
    e.currentTarget.selectionStart = e.currentTarget.selectionEnd = start + 1
  }
}

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  allowTab?: boolean
  className?: string
}

const Textarea: React.FC<Props> = ({
  allowTab = false,
  className,
  onKeyDown,
  children,
  ...rest
}) => {
  return (
    <textarea
      className={cx(
        `border border-coolGray-300 focus:border-orange-400 hover:border-orange-400 caret-orange-400 
         placeholder-coolGray-400 outline-none rounded p-4 text-coolGray-800 w-full
         bg-coolGray-50`,
        className
      )}
      onKeyDown={(e) => {
        if (allowTab) {
          allowTabCharacter(e)
        }
        onKeyDown?.(e)
      }}
      {...rest}
    />
  )
}

export default Textarea
